import React from "react";

function Notification(props) {
  return <div>Notif</div>;
}

export default Notification;
